import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMongolia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1178)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C13.4679 24 14.874 23.736 16.1739 23.2536L16.6957 12L16.1739 0.746391C14.874 0.264047 13.4679 0 12 0C10.5322 0 9.12605 0.264047 7.82612 0.746391L7.30435 12L7.82607 23.2536C9.12605 23.736 10.5322 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2536V0.746399C3.2565 2.44191 0 6.84043 0 12Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1739 0.746399V23.2537C20.7435 21.5581 24 17.1596 24 12C24 6.84043 20.7435 2.44191 16.1739 0.746399Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.73914 12H6.78262V16.1739H5.73914V12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.5652 12H2.60869V16.1739H1.5652V12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.17389 14.6087C4.75019 14.6087 5.21737 14.1415 5.21737 13.5652C5.21737 12.9889 4.75019 12.5217 4.17389 12.5217C3.59759 12.5217 3.1304 12.9889 3.1304 13.5652C3.1304 14.1415 3.59759 14.6087 4.17389 14.6087Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.17389 10.4348C4.46203 10.4348 4.69561 10.2012 4.69561 9.91305C4.69561 9.62491 4.46203 9.39133 4.17389 9.39133C3.88576 9.39133 3.65218 9.62491 3.65218 9.91305C3.65218 10.2012 3.88576 10.4348 4.17389 10.4348Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.13045 15.1305H5.21742V16.1739H3.13045V15.1305Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.13045 10.9565H5.21742V12H3.13045V10.9565Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.17389 6.26086L4.54345 7.39805H5.73914L4.77188 8.1009L5.14116 9.23808L4.17389 8.53524L3.20667 9.23808L3.57595 8.1009L2.60869 7.39805H3.80438L4.17389 6.26086Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1178",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMongolia;
